const isStage = () => (
  (typeof window !== 'undefined' &&
    window.location &&
    window.location.hostname &&
    window.location.hostname.includes('-dev'))
)

export default isStage
